// src\themes\tolica\components\EditorWidget.tsx
import { Heading } from "@/components/ui/Heading";

export default function EditorWidget({ data, isHome = false }: { data: any; isHome?: boolean }) {

    // 1) Extract content from items
    const itemContent =
        data?.items?.length > 0
            ? data.items[0].content ||
            data.items[0].content_en ||
            data.items[0].content_ar
            : null;

    // 1) Choose content based on your backend structure
    const content =
        data.content ||
        data.content_en ||
        data.content_ar ||
        (data.items && data.items[0] && data.items[0].content) ||
        "";

    if (!content) return null;

    // 2) Text alignment
    const textAlign =
        data.direction === "center"
            ? "text-center"
            : data.direction === "right"
                ? "text-end"
                : "text-start";



    // 3) Width mapping (same as other widgets)
    const widthMap: Record<string, string> = {
        "1/1": "col-span-12",
        "1/2": "col-span-12 md:col-span-6",
        "1/3": "col-span-12 md:col-span-4",
        "1/4": "col-span-12 md:col-span-3",
        "2/3": "col-span-12 md:col-span-8",
        "3/4": "col-span-12 md:col-span-9",
    };

    const width = widthMap[data.width || "1/1"];

    // فقط وقتی تمام‌عرضه (۱/۱) و توی صفحه اصلیه فاصله‌ی کناری می‌گیره؛ برای
    // عرض‌های جزئی روی grid gap حساب می‌شه، وگرنه فاصله‌ی بین دو ویجت کنار هم
    // غیرعادی زیاد می‌شه.
    const homePadding = isHome && (data.width === "1/1" || !data.width) ? "px-4 sm:px-6 lg:px-12" : "";

    return (
        <div
            className={`
                ${width}
                w-full
                h-full
                flex flex-col
                space-y-4
                ${textAlign}
                ${homePadding}
            `}
        >
            {/* Some editors may have a title */}
            {data.title && (
                <Heading level={2}>
                    {data.title}
                </Heading>
            )}

            {/* Editor HTML Output */}
            {content && (
                <div
                    className="
                        text-primary-600
                        text-sm
                        leading-6
                        prose max-w-none
                        whitespace-pre-line
                    "
                    dangerouslySetInnerHTML={{ __html: content }}
                />
            )}
        </div>
    );
}